/**
 * Componente LocalizedLink
 * Envoltorio de `Link` de react-router que antepone el prefijo del idioma
 * actual al destino, para que la navegación interna no cambie de idioma.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useLocalizedPath from '../../hooks/useLocalizedPath';

/**
 * @param {Object} props - Propiedades (el resto se pasa a `Link`)
 * @param {string|{pathname: string}} props.to - Destino interno (ruta en español)
 * @returns {JSX.Element} Enlace localizado
 */
const LocalizedLink = ({ to, ...rest }) => {
  const localize = useLocalizedPath();
  const localizedTo =
    typeof to === 'string' ? localize(to) : { ...to, pathname: localize(to.pathname || '/') };

  return <Link to={localizedTo} {...rest} />;
};

LocalizedLink.propTypes = {
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ pathname: PropTypes.string }),
  ]).isRequired,
};

export default LocalizedLink;
